import { GET_ALL_INQUIRIES_SUCCESS, GET_ALL_INQUIRIES_FAIL, LOGOUT, GET_ALL_INQUIRIES_REQUEST } from "./types";
import { GET_ALL_INQUIRY_TYPES_SUCCESS, GET_ALL_INQUIRY_TYPES_FAIL, GET_ALL_INQUIRY_TYPES_REQUEST } from "./types";

import inquiryService from "../services/inquiryService";
import InquiryTypeService from "../services/inquiryTypeService";
  
export const getAllInquiries = () => async (dispatch) => {
  dispatch({ type: GET_ALL_INQUIRIES_REQUEST });
  try {
    const res = await inquiryService.getAllInquiry();
    dispatch({
      type: GET_ALL_INQUIRIES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_INQUIRIES_FAIL,
      payload: err.response.data.error,
    });
  }
};

export const getAllInquiryTypes = () => async (dispatch) => {
  
  dispatch({ type: GET_ALL_INQUIRY_TYPES_REQUEST });
  try {
    const res = await InquiryTypeService.getAllInquiryTypes();
    console.log(res.data)
    dispatch({
      type: GET_ALL_INQUIRY_TYPES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_INQUIRY_TYPES_FAIL,
      payload: err.response.data.error,
    });
  }
}
